import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { FormattedDate } from 'components/intl'
import { Link } from 'react-router-dom'
import uuid from 'uuid'
import { get } from 'lodash'
import { Table, Data } from 'components/layout/Table'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { Modal } from 'containers/misc'
import { Button, ButtonGroup } from 'components/misc'
import { tasks as tasksLayout } from 'constants/layout'
import config from 'config'

export default class TasksAjPreparationTrainingsTable extends Component {
  static propTypes = {
    tasks: PropTypes.object.isRequired,
    list: PropTypes.array.isRequired,
    approveModal: PropTypes.func.isRequired,
    returnModal: PropTypes.func.isRequired,
    setParams: PropTypes.func,
    modal: PropTypes.func.isRequired,
    setCommonLimit: PropTypes.func
  }

  static defaultProps = {
    list: []
  }

  constructor(props) {
    super(props)
    this.key = uuid.v1()
    this.state = {
      ajPrepTrainingId: null,
      ajPrepTrainingIdReturn: null
    }
  }

  handleApproveParticipantEventModal = ajPrepTrainingId => {
    this.setState(
      {
        ajPrepTrainingId
      },
      () => {
        this.props.modal(`modal-approve-aj-participant-event-${this.key}`)
      }
    )
  }

  handleReturnParticipantEventModal = ajPrepTrainingIdReturn => {
    this.setState(
      {
        ajPrepTrainingIdReturn
      },
      () => {
        this.props.modal(`modal-return-aj-participant-event-${this.key}`)
      }
    )
  }

  render() {
    const {
      tasks: { loading, offset, limit, pages, sort },
      list,
      setParams,
      approveModal,
      returnModal,
      setCommonLimit
    } = this.props

    return (
      <div>
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={tasksLayout.ajPreparationTrainings}
          setParams={setParams}
        >
          <Data>
            {list.map(({ id, award, participantPerson, date }) => (

              <tr key={id}>
                <td>
                  <Link to={`${config.publicPath}/participants/${get(participantPerson, 'id')}`}>
                    {get(participantPerson, 'id')}
                  </Link>
                </td>
                <td>{get(participantPerson, 'firstName')}</td>
                <td>{get(participantPerson, 'lastName')}</td>
                <td>{date && <FormattedDate value={date} />}</td>
                <td>
                  <Link
                    className="link"
                    to={`${config.publicPath}/participants/${get(participantPerson, 'id')}/${get(award, 'awardLevel.value').toLowerCase()}-level/aj`}
                  >
                    <FormattedMessage id="button.view" defaultMessage="View" />
                  </Link>
                </td>
                <td>
                  <ButtonGroup right>
                    <Button
                      type="button"
                      tiny
                      onClick={() =>
                        this.handleApproveParticipantEventModal(
                          get(award, 'id')
                        )
                      }
                      intlKey="button.approve"
                    >
                      Approve
                    </Button>
                    <Button
                      type="button"
                      tiny
                      onClick={() =>
                        this.handleReturnParticipantEventModal(get(award, 'id'))
                      }
                      intlKey="button.return"
                      secondary
                    >
                      Revise
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </Data>
        </Table>
        <Modal
          id={`modal-approve-aj-participant-event-${this.key}`}
          customActions
        >
          <TaskApprove
            id={this.state.ajPrepTrainingId}
            approve={approveModal}
            modal={this.props.modal}
          />
        </Modal>
        <Modal
          id={`modal-return-aj-participant-event-${this.key}`}
          customActions
        >
          <TaskReturn
            returnTask={returnModal}
            id={this.state.ajPrepTrainingIdReturn}
            modal={this.props.modal}
          />
        </Modal>
      </div>
    )
  }
}
